<script>
export default {
  name: 'AlertWithAction',
  props: {
    tipo: {
      type: String,
      default: null,
    },
    labelBotao: {
      type: String,
      default: null,
    },
    run: {
      type: Function,
      default: null,
    },
  },
}
</script>

<template>
  <div
    class="alert mb-3 w-100 small d-flex flex-column align-items-start"
    :class="`alert-outline-${tipo || 'warning'}`"
  >
    <div class="d-flex align-items-center">
      <slot name="icone">
      </slot>
      <slot />
    </div>

    <v-button
      v-if="run && labelBotao"
      class="btn btn-sm btn-outline-primary mt-2"
      :popover="true" position="dropup"
      :run="run"
    >
      {{labelBotao}}
    </v-button>
  </div>
</template>

<style scoped>

</style>
